import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingCurrencyOverrideEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingCurrencyOverrideEntity
